import { popup } from '@/utils/mixins/popup'
import { form } from '@/utils/mixins/form'

const formPopup = {
  mixins: [popup, form]
}

export { formPopup }
